import { render, staticRenderFns } from "./BranchAdd.vue?vue&type=template&id=5d0c8a90&"
import script from "./BranchAdd.vue?vue&type=script&lang=ts&"
export * from "./BranchAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports